import { ReactNode, useState } from "react";
import LanguageContext from "context/LanguageContext";
import { useCookies } from "react-cookie";
import { i18n } from "i18n";

export type ILanguage = "en" | "ru";
type TParam = string | number | null | undefined;

export interface ILanguageState {
	language: ILanguage;
	setLanguage: (newLang: ILanguage) => void;
	getTranslate: (path?: string, params?: { [param: string]: TParam }) => string;
}

export const EMPTY_TEXT = "UNKNOWN_WORD";

export interface ITranslate {
	en: string;
	ru?: string;
}

interface IProps {
	children?: ReactNode;
}

export const LanguageProvider = ({ children }: IProps) => {
	const [cookie, setCookie] = useCookies(["language"]);
	const [language, setLanguage] = useState<ILanguage>(
		cookie.language || window.navigator?.language?.substring(0, 2) || "en",
	);

	const getTranslate = (
		path?: string,
		params?: { [param: string]: string | number | null | undefined },
	): string => {
		let text;
		text = path?.split(".")?.reduce((acc, item) => acc?.[item] as any, i18n?.[language]);
		if (text && params) {
			text = Object.keys(params).reduce(
				(acc: any, item) => acc?.replace(`#{${item}}`, params[item]),
				text,
			);
		}
		return text || EMPTY_TEXT;
	};

	const handleChangeLanguage = (newLang: ILanguage) => {
		setLanguage(newLang);
		setCookie("language", newLang, { path: "/", domain: window.location.hostname });
	};

	return (
		<LanguageContext.Provider value={{ language, setLanguage: handleChangeLanguage, getTranslate }}>
			{children}
		</LanguageContext.Provider>
	);
};
